import React from 'react';
import { string, bool, object } from 'prop-types';
import { CheckNearByStore } from './CheckNearByStore';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';

const OffshoreBossUnavailable = ({ itemId, isShipToHomeEligible, stateName, addOnsAssemblyAndMore }) => {

  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Store"
          icon="pick-up-false"
        />
        <div className="fulfillment-msg warning_text">Not available in {stateName}</div>
      </div>
      <TileFooter>
        <CheckNearByStore
          itemId={itemId}
          isShipToHomeEligible={isShipToHomeEligible}
          addOnsAssemblyAndMore={addOnsAssemblyAndMore}
        >
          Change Store
        </CheckNearByStore>
      </TileFooter>
    </>
  );
};
OffshoreBossUnavailable.propTypes = {
  itemId: string.isRequired,
  stateName: string,
  isShipToHomeEligible: bool,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object
};
OffshoreBossUnavailable.defaultProps = {
  stateName: null,
  isShipToHomeEligible: false,
  addOnsAssemblyAndMore: null
};

export { OffshoreBossUnavailable };
